module.exports = __webpack_public_path__ + "static/media/company_4.png";